import React, { useState, useRef, useEffect } from "react";

import Button from "../../base-components/button";
import locale from "../../utilities/locale";
import classes from "./index.module.css";
import TextInput from "../../base-components/text-input";
import { setUserCurrentScreen } from "../../redux/action/app";
import { updateUserProfile } from "../../redux/thunk/app.thunk";
import config from "../../config";
import { openDisclosures } from "../../navigators/routes";
import { useDispatch, useSelector } from "react-redux";

const BankingInfo = () => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.app.isLoading);
  const [accountNumber, setAccountNumber] = useState("");
  const [routingNumber, setRoutingNumber] = useState("");
  const [accountNumberError, setAccountNumberError] = useState(false);
  const [routingNumberError, setRoutingNumberError] = useState(false);

  const onChangeAccountNumber = (event) => {
    console.log(event.target.value);
    setAccountNumber(event.target.value);
    setAccountNumberError(false);
  };

  const onChangeRoutingNumber = (event) => {
    console.log(event.target.value);
    setRoutingNumber(event.target.value);
    setRoutingNumberError(false);
  };

  const onSubmit = () => {
    setAllErrors();
    if (!showAccountNumberError && !showRoutingNumberError) {
      dispatch(
        updateUserProfile({
          accountNumber: accountNumber,
          routingNumber: routingNumber,
        })
      ).then(() => {
        dispatch(setUserCurrentScreen(config.routes.disclosures));
        openDisclosures();
      });
    }
  };

  const showAccountNumberError = accountNumber.length === 0;
  const showRoutingNumberError = routingNumber.length === 0;

  const setAllErrors = () => {
    setAccountNumberError(showAccountNumberError);
    setRoutingNumberError(showRoutingNumberError);
  };

  const onFocusAccountNumber = () => {
    setAccountNumberError(false);
  };

  const onFocusRoutingNumber = () => {
    setRoutingNumberError(false);
  };

  return (
    <div className={classes.Container}>
      <div className={classes.top}>
        <h2 className={classes.Heading}>{locale.BANKING_INFO_HEADING}</h2>
      </div>
      <div className={classes.middle}>
        <div className={classes.textInput}>
          <TextInput
            id="example-3"
            label={locale.BANKING_INFO_ACCOUNT_NUMBER}
            onFocus={onFocusAccountNumber}
            onChange={onChangeAccountNumber}
            showError={accountNumberError}
            errorMessage={locale.ACCOUNT_NUMBER_ERROR_MESSAGE}
          />
        </div>
        <div className={classes.textInput}>
          <TextInput
            id="example-3"
            label={locale.BANKING_INFO_ROUTING_NUMBER}
            onFocus={onFocusRoutingNumber}
            onChange={onChangeRoutingNumber}
            showError={routingNumberError}
            errorMessage={locale.ROUTING_NUMBER_ERROR_MESSAGE}
          />
        </div>
      </div>
      <div className={classes.bottom}>
        <Button
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            height: "50px",
            alignItems: "center",
          }}
          loading={isLoading}
          state={undefined}
          action={onSubmit}
          disabled={accountNumberError || routingNumberError}
        >
          {locale.CONTINUE}
        </Button>
      </div>
    </div>
  );
};

export default BankingInfo;
